import Stack from '@mui/material/Stack';

import { TabId } from '../../types';
import { WorkflowInfoToolbar } from '../WorkflowInfoToolbar';

type Props = {
  isExistingWorkflow: boolean;
  toggleDescriptionPanelExpanded: () => void;
  workflowId: string | undefined;
  activeTabId: TabId;
  onChangeTab: (tabId: TabId) => void;
};

export const MainToolbar = ({
  isExistingWorkflow,
  toggleDescriptionPanelExpanded,
  workflowId,
  activeTabId,
  onChangeTab,
}: Props): JSX.Element => {
  return (
    <Stack
      flexDirection="row"
      flexWrap="wrap"
      justifyContent="space-between"
      sx={{ borderBottom: '1px solid', borderColor: 'grey.400' }}
    >
      <WorkflowInfoToolbar
        isExistingWorkflow={isExistingWorkflow}
        onClickExpandIcon={toggleDescriptionPanelExpanded}
        workflowId={workflowId}
        activeTabId={activeTabId}
        onChangeTab={onChangeTab}
      />
    </Stack>
  );
};
